import React, { Component, PropTypes } from 'react';
import { Units } from 'Css';
import classNames from 'classnames';
import { Colors } from 'Css';

const css = oxygenCss({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    content: {
      zIndex: 1,
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      overflow: 'auto',
      '&padded': {
        padding: Units.base
      },
      '&hasHeader': {
        top: Units.keyline
      },
      '&hasFooter': {
        bottom: Units.keyline
      }
    }
  }
});

class DialogContent extends Component {
  static propTypes = {
    children: PropTypes.node,
    padded: PropTypes.bool,
    header: PropTypes.node,
    footer: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const {
      className,
      padded,
      header,
      footer,
      children,
      ...other
    } = this.props;
    const classes = classNames(css.content, className, {
      [css.hasHeader]: header,
      [css.hasFooter]: footer,
      [css.padded]: padded
    });
    return (
      <div className={css.root} {...other}>
        {header}
        <div className={classes}>{children}</div>
        {footer}
      </div>
    );
  }
}

export default DialogContent;



// WEBPACK FOOTER //
// ./src/js/components/Dialog/DialogContent.js